var _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinnerDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 0,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "r",
    begin: "0;svgSpinners3DotsMove1.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "0;3"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "cx",
    begin: "svgSpinners3DotsMove7.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "4;12"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "cx",
    begin: "svgSpinners3DotsMove5.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "12;20"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsMove0",
    fill: "freeze",
    attributeName: "r",
    begin: "svgSpinners3DotsMove3.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "3;0"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsMove1",
    fill: "freeze",
    attributeName: "cx",
    begin: "svgSpinners3DotsMove0.end",
    dur: "0.001s",
    values: "20;4"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "cx",
    begin: "0;svgSpinners3DotsMove1.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "4;12"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "cx",
    begin: "svgSpinners3DotsMove7.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "12;20"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsMove2",
    fill: "freeze",
    attributeName: "r",
    begin: "svgSpinners3DotsMove5.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "3;0"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsMove3",
    fill: "freeze",
    attributeName: "cx",
    begin: "svgSpinners3DotsMove2.end",
    dur: "0.001s",
    values: "20;4"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "r",
    begin: "svgSpinners3DotsMove3.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "0;3"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "cx",
    begin: "0;svgSpinners3DotsMove1.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "12;20"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsMove4",
    fill: "freeze",
    attributeName: "r",
    begin: "svgSpinners3DotsMove7.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "3;0"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsMove5",
    fill: "freeze",
    attributeName: "cx",
    begin: "svgSpinners3DotsMove4.end",
    dur: "0.001s",
    values: "20;4"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "r",
    begin: "svgSpinners3DotsMove5.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "0;3"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "cx",
    begin: "svgSpinners3DotsMove3.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "4;12"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsMove6",
    fill: "freeze",
    attributeName: "r",
    begin: "0;svgSpinners3DotsMove1.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "3;0"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsMove7",
    fill: "freeze",
    attributeName: "cx",
    begin: "svgSpinners3DotsMove6.end",
    dur: "0.001s",
    values: "20;4"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "r",
    begin: "svgSpinners3DotsMove7.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "0;3"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "cx",
    begin: "svgSpinners3DotsMove5.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "4;12"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "cx",
    begin: "svgSpinners3DotsMove3.end",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "12;20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerDots);
export default __webpack_public_path__ + "static/media/spinner-dots.58a70c8bcea620418e534f315604fcab.svg";
export { ForwardRef as ReactComponent };